module.exports = __webpack_public_path__ + "img/favicon.9d481a6c.png";